import { IStyle, classNamesFunction } from '@fluentui/react';
import { IThemedProp } from './themesUI';

export interface IVsbUpsellAlertStyles {
    upsellAlertContainer: IStyle;
    upsellAlert: IStyle;
    upsellAlertMessageTitle: IStyle;
    upsellAlertButtonSection: IStyle;
    button: IStyle;
    overflowTextElement: IStyle;
}

export interface VsbUpsellAlertProps {
    isGetHelp: boolean;
}

export const getVsbUpsellAlertStyles = (props: IThemedProp & VsbUpsellAlertProps): IVsbUpsellAlertStyles => {
    const { theme, isGetHelp } = props;
    return {
        upsellAlertContainer: {
            minWidth: '540px',
            textAlign: 'start',
        },
        upsellAlert: {
            backgroundColor: theme.palette.neutralLighter,
            color: theme.palette.neutralPrimary,
            marginBottom: isGetHelp && '20px',
        },
        upsellAlertMessageTitle: {
            fontWeight: '600',
            fontSize: '14px',
            marginBottom: '10px',
        },
        upsellAlertButtonSection: {
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: '17px',
        },
        button: {
            maxWidth: '180px',
            height: '30px',
            fontSize: '14px',
            padding: '4px 11px 6px',
            border: `1px solid ${theme.palette.neutralTertiaryAlt}`,
            borderRadius: '3px',
        },
        overflowTextElement: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    };
};

export const getNoIconMessageBarStyles = () => {
    return {
        text: {
            margin: 'auto',
            padding: '20px 0px 20px 0px',
        },
        dismissal: {
            width: '16px',
            height: '16px',
            margin: '20px',
            padding: '0px',
        },
    };
};

export const getMessageBarButtonStyles = () => {
    return {
        label: {
            fontWeight: '400',
        },
    };
};

export const getVsbUpsellAlertClassNames = classNamesFunction<{}, IVsbUpsellAlertStyles>();
